import { MutationTree } from 'vuex'
import { SessionStoreInterface } from 'src/store/session/state'
import { Asset, Item, ItemSetting } from 'able-lib'
import { setProp } from 'src/lib/helper'

const mutation: MutationTree<SessionStoreInterface> = {
  startSession (state: SessionStoreInterface, session: Item) {
    setProp(state, ['session'], session)
  },

  setSessionSettings (state: SessionStoreInterface, sessionSettings: Array<ItemSetting>) {
    state.sessionSettings = sessionSettings
  },

  setSessionSettingConnected (state: SessionStoreInterface, value: boolean) {
    state.sessionSettingConnected = value
  },

  setMaterials (state: SessionStoreInterface, materials: Array<Asset>) {
    state.contentMaterials = materials
  },

  SET_RECOGNITIONS (state: SessionStoreInterface, userRecognitions) {
    setProp(state.session, ['itemRecognitions'], userRecognitions)
  },

  UPDATE_NOTE (state: SessionStoreInterface, value: boolean) {
    state.participantsSetting.note = value
  },

  UPDATE_CHAT (state: SessionStoreInterface, value: boolean) {
    state.participantsSetting.chat = value
  },

  SHOW_EXTERNAL_LINK (state: SessionStoreInterface, url: string) {
    state.externalLink = {
      url,
      show: true
    }
  },

  HIDE_EXTERNAL_LINK (state: SessionStoreInterface) {
    state.externalLink = {
      url: '',
      show: false
    }
  }
}

export default mutation
